module.exports = __webpack_public_path__ + "static/media/cyuce0002.6f9e4438.jpg";